module.exports = __webpack_public_path__ + "img/vertical_4_3_3009.243c4789.png";